import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["Spinner"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/spinner/spinner.js");
